import { createSelector } from "reselect"
import { find, map, get } from "lodash"
import { getSelectedDate } from "modules/security-profile/selectors/dates"
import { computeDrift } from "helpers/drift"
import { getFilteredData, getCategoryItems, getDrift } from "./data"

export const getDetails = createSelector(
  [getFilteredData, getDrift, getCategoryItems, getSelectedDate],
  (data, driftValues, items, date) => {
    const datum = find(data, d => d.date.isSame(date))

    return map(items, item => {
      const value = get(datum, item.id)
      let drift
      const driftValue = driftValues[item.id]
      if (driftValue) {
        drift = computeDrift(driftValue.mean, driftValue.stdDev, value)
      } else {
        drift = "-"
      }

      return {
        ...item,
        value,
        drift,
      }
    })
  },
)
